/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/* eslint-disable array-callback-return */
import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';

import AddressHelper from '../OrderDetails/Helper/AddressHelper';
import DesktopPaymentMethod from './DesktopBillingDetail/DesktopPaymentMethod';
import OrderSummaryHelper from '../OrderDetails/Helper/OrderSummaryHelper';

class DesktopBillingDetail extends React.PureComponent {
    render() {
        const { orderDetailById } = this.props;

        if (orderDetailById.length < 1) return null;

        // console.log('orderDetailById', orderDetailById);

        const { billingDetail } = orderDetailById[0];

        if (!billingDetail) return null;

        const {
            cardNumber,
            cardType,
            thirdPartyType,
            giftCardPayments,
            billingPersonProfile: {
                firstName,
                lastName,
                businessName,
                address,
                phone,
                emailAddress,
            },
        } = billingDetail;

        return (
            <Card className="margin-top delivery-info">
                <CardContent className="padding-10">
                    <Grid container>
                        <Grid item xs={4}>
                            <h2 className="gray-color">Billing Address</h2>
                            <div className="margin-bottom">
                                <div className="">
                                    {firstName} {lastName}
                                </div>
                                {businessName ? <div>{businessName}</div> : ''}
                                <AddressHelper address={address} phone={phone} />
                                <div>{emailAddress}</div>
                            </div>
                        </Grid>
                        <Grid item xs={4}>
                            <DesktopPaymentMethod
                                data={{
                                    cardNumber,
                                    cardType,
                                    thirdPartyType,
                                    giftCardPayments,
                                }}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <h2 className="gray-color">Order Payment Summary</h2>
                            <OrderSummaryHelper
                                data={{
                                    orderDetailById,
                                    cardType,
                                    cardNumber,
                                    thirdPartyType,
                                    giftCardPayments,
                                }}
                            />
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        );
    }
}

DesktopBillingDetail.propTypes = {
    orderDetailById: PropTypes.array.isRequired,
};

export default DesktopBillingDetail;
